export default {
  groupName: 'financial-services-banking',
  appName: 'Banking & CC Ad Effect Tracker',
  baseRoute: '/dashboard/financial-services-banking',
  label: 'Banking & CC Ad Effect Tracker Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Banking & CC Ad Effect Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/main.js